import React, { useEffect, useRef, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useDispatch, useSelector } from "react-redux";
import Meta from "../../components/Meta";
import { addNotification } from "../../components/Notification";
import Image from "next/image";
import SimpleReactValidator from "simple-react-validator";
import DynamicDropdown from "../../components/dropdown/customDropdown";
import requestHandler from "../../redux/httpClient";
import MySpinner from "../../components/spinner";
import { fetchNetwork } from "../../redux/getNetworks";
import { fetchCategory } from "../../redux/getCategory";
import { useRouter } from "next/router";
import { fetchCollections } from "../../redux/getCollections";
import { useMetaMask } from "metamask-react";
import { walletModalShow } from "../../redux/counterSlice";
import { ethers } from "ethers";
import { checkMetaMaskConnection, deployContract } from "../../context/deployContract";

const Create = () => {
  const [file, setFile] = useState("");
  const [banner, setBanner] = useState("");
  const [name, setName] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [description, setDescription] = useState("");
  const [socialMediaFirstLink, setSocialMediaFirstLink] = useState("");
  const [socialMediaSecondLink, setSocialMediaSecondLink] = useState("");
  const [socialMediaThirdLink, setSocialMediaThirdLink] = useState("");
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState("");
  const [networkText, setNetworkText] = useState("Select a value");
  const [networkValue, setNetworkValue] = useState("");
  const [categoryText, setCategoryText] = useState("Select a value");
  const [categoryValue, setCategoryValue] = useState("");
  const [networkSymbol, setNetworkSymbol] = useState("");
  const [networkActive, setNetworkActive] = useState(null);
  const [categoryOption, setCategoryOption] = useState({});
  const [networkOption, setNetworkOption] = useState({});
  const [categoryOptions, setCategoryOptions] = useState();
  const [networkOptions, setNetworkOptions] = useState();
  const [loading, setLoading] = useState(false);
  const { categoryData } = useSelector(state => state.getCategory);
  const { networkData } = useSelector(state => state.getNetworks);
  const dispatch = useDispatch();
  const router = useRouter();
  const { status, connect, account, chainId, ethereum } = useMetaMask();
  const [address, setAddress] = useState();
  const [contractInstance, setContractInstance] = useState(null);

  const convertedSocialMediaLinks = {
    socialMediaFirstLink,
    socialMediaSecondLink,
    socialMediaThirdLink,
  };

  const ContractAbi = [
    {
      inputs: [],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "subtractedValue",
          type: "uint256",
        },
      ],
      name: "decreaseAllowance",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "addedValue",
          type: "uint256",
        },
      ],
      name: "increaseAllowance",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
  ];

  const socialMediaIntoJson = JSON.stringify(convertedSocialMediaLinks);

  useEffect(() => {
    if (networkData?.length === 0) {
      dispatch(fetchNetwork());
    }
    if (categoryData?.length === 0) {
      dispatch(fetchCategory());
    }
  }, []);

  const handleCategoryData = (option) => {
    setCategoryOption(option);
    setCategoryValue(option.id);
    setCategoryText(option.label);
  };

  const handleNetworkData = (option) => {
    setNetworkValue(option.id);
    setNetworkText(option.label);
    let symbol = option?.label?.split(" ")[1]?.split("(")[1]?.split(")")[0];
    setNetworkSymbol(symbol);
  };

  const handleConnect = async () => {
    if (status === 'notConnected') {
      await connect();
    }
  };

  // const createCollectionHandler = async () => {
  //   setLoading(true);
  //   try {
  //     // await deployContract();
  //     // await handleConnect();
  //     if (status === 'notInstalled' || status === 'unavailable') {
  //       const metaMaskUrl = 'https://metamask.io/download.html';
  //       if (window.confirm('MetaMask is not installed. Would you like to install it?')) {
  //         window.open(metaMaskUrl, '_blank');
  //         setLoading(false);
  //       }
  //     }
  //     else {
  //       await handleConnect();
  //       if (status === 'connected') {
  //         // await deployContract();
  //         const deployedContract = await deployContract(account);

  //         // console.log("deployedContract", deployedContract);
  //         // if (deployedContract && deployedContract.getAddress()) {
  //         if (deployedContract.code !== "ACTION_REJECTED") {
  //           let data = {
  //             category_id: categoryValue,
  //             name: name,
  //             network: networkValue,
  //             walletAddress: account,
  //             symbol: networkSymbol,
  //             royalty: 3,
  //             socialMediaLinks: socialMediaIntoJson,
  //             description: description,
  //             subHeading: subHeading,
  //             logo: file,
  //             banner: banner,
  //           };
  //           try {
  //             const addCollectionHandler = await requestHandler("collection/collectionCreate", "post", data, "jwt_token", "file");
  //             setLoading(false);
  //             if (addCollectionHandler?.status === 200) {
  //               addNotification({
  //                 title: "Success",
  //                 message: addCollectionHandler?.data?.message,
  //                 type: "success",
  //               });
  //               router.push("/");
  //               dispatch(fetchCollections());
  //             }
  //           }
  //           catch (e) {
  //             console.log("catch", e);
  //             setLoading(false);
  //           };
  //         }
  //         else {
  //           setLoading(false);
  //           addNotification({
  //             title: "Error",
  //             message: "User has denied the transaction",
  //             type: "danger",
  //           });
  //         }


  //       }
  //       else {
  //         setLoading(false);
  //       }
  //     }
  //   }
  //   catch (e) {
  //     setLoading(false);
  //   }
  // };

  const createCollectionHandler = async () => {
    setLoading(true);
    try {
      if (status === 'notInstalled' || status === 'unavailable') {
        const metaMaskUrl = 'https://metamask.io/download.html';
        if (window.confirm('MetaMask is not installed. Would you like to install it?')) {
          window.open(metaMaskUrl, '_blank');
          setLoading(false);
        }
      } else {
        await handleConnect();
        if (status === 'connected') {
          const deployedContract = await deployContract();
          // console.log("deployedContract", deployedContract.target);

          if (deployedContract && !deployedContract.code) {
            let data = {
              category_id: categoryValue,
              name: name,
              network: networkValue,
              walletAddress: account,
              symbol: networkSymbol,
              royalty: 3,
              socialMediaLinks: socialMediaIntoJson,
              description: description,
              subHeading: subHeading,
              logo: file,
              banner: banner,
              contractAddress: deployedContract.target,
            };
            try {
              const addCollectionHandler = await requestHandler("collection/collectionCreate", "post", data, "jwt_token", "file");
              setLoading(false);
              if (addCollectionHandler?.status === 200) {
                addNotification({
                  title: "Success",
                  message: addCollectionHandler?.data?.message,
                  type: "success",
                });
                router.push("/");
                dispatch(fetchCollections());
              }
            } catch (e) {
              // console.log("catch", e);
              setLoading(false);
            }
          } else {
            setLoading(false);
            addNotification({
              title: "Error",
              message: "User has denied the transaction or deployment failed",
              type: "danger",
            });
          }
        } else {
          setLoading(false);
        }
      }
    } catch (e) {
      // console.error("Error in createCollectionHandler:", e);
      setLoading(false);
    }
  };


  useEffect(() => {
    if (categoryData) {
      let newArr = categoryData?.map((x) => {
        return {
          label: x.name,
          value: x.name,
          id: x.id,
        }
      });
      setCategoryText(newArr[0]?.label);
      setCategoryValue(newArr[0]?.id);
      setCategoryOptions(newArr);
    }
  }, [categoryData]);

  useEffect(() => {
    if (networkData) {
      let newArr = networkData?.map((x) => {
        return {
          // label: `${x.name}`,
          // value: `${x.name}`,
          label: `${x.name} (${x.symbol?.toUpperCase()})`,
          value: `${x.name} (${x.symbol?.toUpperCase()})`,
          id: x.id,
        };
      });
      setNetworkOptions(newArr);
      setNetworkText(newArr[0]?.label);
      setNetworkValue(newArr[0]?.id);
      let symbol = newArr[0]?.label?.split(" ")[1]?.split("(")[1]?.split(")")[0];
      setNetworkSymbol(symbol);
    }
  }, [networkData]);

  return (
    <div>
      {loading && <MySpinner />}
      <Meta title="Create Collection" />
      {/* <!-- Create --> */}
      <section className="relative py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="container">
          <h1 className="font-display text-jacarta-700 py-16 text-center text-4xl font-medium dark:text-white">
            Add Collection
          </h1>

          <div className="mx-auto max-w-[48.125rem]">
            <div className="mb-6">
              <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                Logo
                <span className="text-red">*</span>
              </label>
              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 group relative flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed bg-white py-20 px-5 text-center">
                <div className="relative z-10 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-500 mb-4 inline-block dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                  </svg>
                </div>
                <div className="dark:bg-jacarta-600 bg-jacarta-50 absolute inset-4 cursor-pointer rounded opacity-0 group-hover:opacity-100 ">
                  <input
                    type="file"
                    onChange={(e) => {
                      setFile(e.target.files[0])
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="mb-6">
              <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                Banner Image
                <span className="text-red">*</span>
              </label>
              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 group relative flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed bg-white py-20 px-5 text-center">
                <div className="relative z-10 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-jacarta-500 mb-4 inline-block dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                  </svg>
                </div>
                <div className="dark:bg-jacarta-600 bg-jacarta-50 absolute inset-4 cursor-pointer rounded opacity-0 group-hover:opacity-100 ">
                  <input
                    type="file"
                    onChange={(e) => {
                      setBanner(e.target.files[0])
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-name"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Collection Name
                <span className="text-red">*</span>
              </label>
              <input
                type="text"
                id="item-name"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Item name"
                required
                name="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                onBlur={() => { simpleValidator.current.showMessageFor("name"); }}
              />
            </div>
            <span className="text-red">
              {simpleValidator.current.message("name", name, "required")}
            </span>
            <div className="mb-6">
              <label
                htmlFor="item-name"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                SubHeading
                <span className="text-red">*</span>
              </label>
              <input
                type="text"
                id="item-name"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Item name"
                required
                name="subHeading"
                value={subHeading}
                onChange={(e) => {
                  setSubHeading(e.target.value);
                }}
                onBlur={() => { simpleValidator.current.showMessageFor("subHeading"); }}
              />
            </div>
            <span className="text-red">
              {simpleValidator.current.message("sub heading", subHeading, "required")}
            </span>
            <div className="mb-6">
              <label
                htmlFor="item-description"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Description
              </label>
              <p className="dark:text-jacarta-300 text-2xs mb-3">
                The description will be included on the item's detail page underneath its image. Markdown syntax is supported.
              </p>
              <textarea
                id="item-description"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                rows="4"
                required
                placeholder="Provide a detailed description of your item."
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                name="description"
                onBlur={() => { simpleValidator.current.showMessageFor("description"); }}
              ></textarea>
            </div>
            <span className="text-red">
              {simpleValidator.current.message("description", description, "required")}
            </span>
            <div className="relative">
              <div>
                <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                  Category
                </label>
                <div className="mb-3 flex items-center space-x-2">
                  <p className="dark:text-jacarta-300 text-2xs">
                    This is the collection where your item will appear.
                    <Tippy
                      theme="tomato-theme"
                      content={
                        <span>
                          Moving items to a different collection may take up to
                          30 minutes.
                        </span>
                      }
                    >
                      <span className="inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          className="dark:fill-jacarta-300 fill-jacarta-500 ml-1 -mb-[3px] h-4 w-4"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"></path>
                        </svg>
                      </span>
                    </Tippy>
                  </p>
                </div>
              </div>
              <div className="dropdown my-1 cursor-pointer">
                <DynamicDropdown
                  options={categoryOptions}
                  onSelect={handleCategoryData}
                  text={categoryText}
                />
              </div>
            </div>
            <div className="relative">
              <div>
                <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                  Network
                </label>
              </div>
              <div className="dropdown my-1 cursor-pointer">
                <DynamicDropdown
                  options={networkOptions}
                  onSelect={handleNetworkData}
                  text={networkText}
                />
              </div>
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-external-link"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Social Media Link
              </label>
              <input
                type="url"
                id="item-external-link"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Please enter the link here"
                value={socialMediaFirstLink}
                onChange={(e) => {
                  setSocialMediaFirstLink(e.target.value);
                }}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-external-link"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Social Media Link
              </label>
              <input
                type="url"
                id="item-external-link"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Please enter the link here"
                value={socialMediaSecondLink}
                onChange={(e) => {
                  setSocialMediaSecondLink(e.target.value);
                }}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="item-external-link"
                className="font-display text-jacarta-700 mb-2 block dark:text-white"
              >
                Social Media Link
              </label>
              <input
                type="url"
                id="item-external-link"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Please enter the link here"
                value={socialMediaThirdLink}
                onChange={(e) => {
                  setSocialMediaThirdLink(e.target.value);
                }}
              />
            </div>

            {/* {contractInstance && (
              <div>Deployed Contract Address: {contractInstance}</div>
            )} */}

            <button
              onClick={(e) => {
                e.preventDefault();
                if (simpleValidator.current.allValid()) {
                  // if (networkText !== "Select a value" && categoryText != "Select a value") {
                  if (file && banner) {
                    createCollectionHandler();
                  }
                  else {
                    addNotification({
                      title: "Alert",
                      message: "Please select logo and banner.",
                      type: "danger",
                    });
                  }
                  // }
                  // else {
                  //   addNotification({
                  //     title: "Alert",
                  //     message: "You need to select category and network to create a collection.",
                  //     type: "danger",
                  //   });
                  // }
                }
                else {
                  simpleValidator.current.showMessages();
                  forceUpdate(1);
                }
              }}
              className="bg-accent-dark cursor-pointer rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
            >
              Submit
            </button>
          </div>
        </div>
      </section>
      {/* <!-- end create --> */}
    </div>
  );
};

export default Create;
